import React, { useCallback, useEffect, useState } from "react";
import { addNotification as notify } from "reapop";
import { connect } from "react-redux";
import AdminNavigation from "./AdminNavigation";
import { countryMenuFields } from "./ManageTranslationField";
import { validateField } from "../../pages/functions";
import Select from "../../forms/Select";
import { api } from "../index.api";
import "./styles.css";

const ManageCountryMenu = props => {
  const [fields, setFields] = useState(countryMenuFields);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedUserType, setSelectedUserType] = useState("");
  const [userType, setUserType] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [countryConfig, setCountryConfig] = useState({});
  const [navMenuUserTypeOptions, setNavMenuUserTypeOptions] = useState([]);
  const [countryMenuPages, setCountryMenuPages] = useState([]);
  const [disableSubmit, seDisableSubmit] = useState(true);

  const resetState = useCallback(() => {
    let fieldsValue = fields;
    setSelectedCountry("");
    setSelectedUserType("");
    setCountryMenuPages([]);
    setCountryConfig({});
    seDisableSubmit(true);
    fieldsValue.country.value = "";
    fieldsValue.loginUserType.value = "";
    setFields({...fieldsValue});
  });
  const getCountriesList = useCallback(() => {
    const countryOptions = [];
    api.fetchCountriesList(({ COUNTRY }) => {
      COUNTRY.forEach((country) => {
        countryOptions.push({ value: country.name, label: country.name });
      });
      setCountryOptions(countryOptions);
    });
  }, []);

  const getNavMenuUserTypeList = useCallback(() => {
    api.admin.manageCountryConfig.fetchNavMenuList((UserTypeList) => {
      const userTypeOptions = Array.from(
        new Set(UserTypeList.map((item) => item.userType.trim()))
      ).map((userType) => ({
        value: userType,
        label: userType,
      }));
      setUserType(UserTypeList);
      setNavMenuUserTypeOptions(userTypeOptions);
    });
  }, []);

  useEffect(() => {
    resetState();
    if (countryOptions.length === 0) {
      getCountriesList();
    }
    if (navMenuUserTypeOptions.length === 0 || userType.length === 0) {
      getNavMenuUserTypeList();
    }
  }, []);

  const validate = useCallback((e, field) => {
    const validateFields = validateField(e, field, fields);
    setFields({ ...validateFields });
  }, []);

  const handleCountryChange = useCallback((event) => {
    let fieldsValue = fields;
    seDisableSubmit(true);
    setSelectedCountry(event);
    setSelectedUserType("");
    fieldsValue.loginUserType.value = "";
    setFields({...fieldsValue});
    api.admin.manageCountryConfig.fetchCountryConfig(event, (res) => {
      setCountryConfig(res);
    });
  }, []);

  const handleUserTypeChange = useCallback(
    (event) => {
      setSelectedUserType(event);
      const menuFields = userType.filter((item) => item.userType === event);
      setCountryMenuPages(menuFields);
    },
    [userType]
  );

  const handleChangeTabMenu = useCallback((fieldName) => {
    seDisableSubmit(false);
    setCountryConfig((prevState) => ({
      ...prevState,
      [fieldName]: prevState[fieldName] ? 0 : 1
    }));
  }, []);

  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  const submitCountryConfigHandler = (res) => {
    if (res.status === 200) {
      resetState();
      showNotification("Success", "Request submited successfully", "success");
    } else {
      showNotification("Error", "Please try again later", "error");
    }
  };

  const handleSubmit = useCallback(() => {
    api.admin.manageCountryConfig.submitCountryConfig(countryConfig, submitCountryConfigHandler);
  }, [countryConfig]);

  return (
    <div id="manage-admin-list" className="v2_container">
      <div className="row">
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row manage-admin-list-header">
            <div className="col-12 col-xl-12">
              <h3 className="mb-3 header-primary">Manage Country Menu</h3>
            </div>
          </div>
          <div>
            <div className="row">
              <div className=" col-md-4">
                <Select
                  searchable
                  clearable={false}
                  options={countryOptions}
                  field={fields.country}
                  validate={(e) => validate(e, fields.country)}
                  onChange={(e) => handleCountryChange(e)}
                />
              </div>
              {selectedCountry && (
                <div className=" col-md-4">
                  <Select
                    searchable
                    clearable={false}
                    options={navMenuUserTypeOptions}
                    disabled={!selectedCountry}
                    field={fields.loginUserType}
                    validate={(e) => validate(e, fields.loginUserType)}
                    onChange={(e) => handleUserTypeChange(e)}
                  />
                </div>
              )}
            </div>
            <div className="ManageCountryMenuBody_wrapper">
              {selectedCountry &&
                selectedUserType &&
                countryConfig &&
                countryMenuPages.map((item) => {
                  return (
                    <div className="ManageCountryMenuBody">
                      <span
                        className="product-visibility-icon"
                        onClick={() => handleChangeTabMenu(item.fieldName)}
                        
                      >
                        <i
                          className={
                            countryConfig[item.fieldName]
                              ? "fa fa-icon fa-eye"
                              : "fa fa-icon fa-eye-slash"
                          }
                        />
                      </span>
                      {item.tabName}
                    </div>
                  );
                })}
            </div>
            <div>
              <button
                className="btn btn-lg btn-info btn-rounded save_button"
                onClick={() => handleSubmit()}
                disabled={disableSubmit}
              >
                Save
              </button>
              <button
                className="btn btn-lg btn-info btn-rounded"
                onClick={() => resetState()}
              >
                cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { notify })(ManageCountryMenu);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/ManageCountryMenu.js